import React from 'react';
import './index.css'
import ReactDOM from 'react-dom';
import Routes from './Routes';

ReactDOM.render(<Routes />,document.getElementById('root'))
